/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 07-07-2026
 *
 * Simfeedback-icoon (uitroepteken) bij een node: toont per node de meldingen
 * die de simfeedback-engine tijdens de simulatie voor die node heeft opgeleverd.
 * Vervangt de ng1 `simfeedback`-directive.
 */
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DlNodeDomBallonComponent} from '../dl-node-dom-ballon/dl-node-dom-ballon.component';
import {BaseFeedbackIconComponent} from '../base-feedback-icon.component';

@Component({
    selector: 'dl-simfeedback',
    standalone: true,
    imports: [DlNodeDomBallonComponent, TranslateModule],
    templateUrl: './dl-simfeedback.component.html',
    styleUrls: ['./dl-simfeedback.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DlSimfeedbackComponent extends BaseFeedbackIconComponent {

    protected readonly iconSelector = '.simfeedback-container .simfeedback';

    //Of er een melding bij kwam staat sinds de herbouw van de "is nieuw"-bepaling in de meldingen
    //zelf; de basis leest hem daar. Bij de simfeedback is dat antwoord in de praktijk altijd `false`
    //— de uitslag is statisch zolang de simulatie open staat (ontwerp-isnieuw.md § 6).
}
